export default __webpack_public_path__ + "static/media/phone.e810c6be.svg";